import ReportTableToolbar from './report-table-toolbar-container'

export default ReportTableToolbar